import { cloneDeep } from "lodash";

/**
 * update survey json inputMaskPattern to standard input mask.
 * background: admin-portal not support input mask settings(old survey version), instead we added a custom-property: inputMaskPattern: "### ####", so need to convert here.
 * example:
 * source: { type: "text", name: "question1", title: "question1", inputMaskPattern: "### ####" }
 * target: { type: "text", name: "question1", title: "question1", "maskType": "pattern",  "maskSettings": {"pattern": "### ####"} }
 * @param surveyJson
 * @returns
 */
export function convertInputMaskPattern(surveyJson: any): any {
  let json = cloneDeep(surveyJson); // avoid TypeError: Cannot assign to read only property '0' of object '[object Array]'
  if (Array.isArray(json)) {
    for (let i = 0; i < json.length; i++) {
      json[i] = convertInputMaskPattern(json[i]);
    }
  } else if (typeof json === "object") {
    if(json!= null){
      if (json.hasOwnProperty("elements") && Array.isArray(json.elements)) {
        for (let i = 0; i < json.elements.length; i++) {
          if (
            json.elements[i].type === "text" &&
            json.elements[i].hasOwnProperty("inputMaskPattern")
          ) {
            json.elements[i].maskType = "pattern";
            json.elements[i].maskSettings = {
              pattern: json.elements[i].inputMaskPattern,
            };
            // delete json.elements[i].inputMaskPattern;
          }
          json.elements[i] = convertInputMaskPattern(json.elements[i]);
        }
      }

      for (const key in json) {
        if (typeof json[key] === "object") {
          json[key] = convertInputMaskPattern(json[key]);
        }
      }
    }
  }

  return json;
}
